import http from "./httpService";
import jwtDecode from "jwt-decode";
import config from "./../config.json";
import { TOKEN_KEY } from "./../utils/constants";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "auth/token/employees";

const loginAsync = async (email, password) => {
  const { data } = await http.post(apiEndpoint, { email, password });
  const { result } = data;

  localStorage.setItem(TOKEN_KEY, result.token);
};

const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const getCurrentUser = () => {
  try {
    const jwt = localStorage.getItem(TOKEN_KEY);
    return jwtDecode(jwt);
  } catch (error) {
    return null;
  }
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const authService = {
  loginAsync,
  logout,
  getCurrentUser,
  getToken,
};

export default authService;
